/**
 * Web "is it hearing me" meter — the twin of `VoiceLevelMeter.tsx`.
 *
 * Four short bars beside the stop button while voice input is listening. They
 * sit flat in silence and rise only with the signal. Browsers report no mic
 * volume to the speech API, so on web the signal is the pulse `useVoiceInput`
 * emits each time recognised words arrive — the bars move when words land.
 * Heights run on the compositor via `--voice-level` (see global.css).
 */
import type { CSSProperties, FC } from 'react';

export interface VoiceLevelMeterProps {
  /** 0..1 */
  level: number;
  className?: string;
}

export const VoiceLevelMeter: FC<VoiceLevelMeterProps> = ({ level, className }) => (
  <span
    className={['tabbio-voice-meter', className].filter(Boolean).join(' ')}
    style={{ '--voice-level': String(Math.max(0, Math.min(1, level))) } as CSSProperties}
    aria-hidden="true"
  >
    <span />
    <span />
    <span />
    <span />
  </span>
);

export default VoiceLevelMeter;
